import axios from "axios";

// Prefer same-origin so API calls always hit the ingress that serves this page.
// Works on both the preview URL and the custom production domain
// (urbanpainter.in), regardless of what REACT_APP_BACKEND_URL was baked into
// the build. Falls back to the build-time env value in non-browser contexts.
const BACKEND_URL =
  (typeof window !== "undefined" && window.location && window.location.origin) ||
  process.env.REACT_APP_BACKEND_URL ||
  "";

export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export async function submitLead(payload) {
  const { data } = await api.post("/leads", payload);
  return data;
}
